export const categoryEnum = {
    REGULAR_GUEST: 'Convidado Padrão',
    SPECIAL_GUEST: 'Convidado Especial',
    SPEAKER: 'Palestrante',
    STAFF: 'Staff',
};
